export default function loginPage() {
  const selectors = {
    loginPage: '.template-login',
    customerLoginForm: '#customer_login',
  }

  const loginPageElement = document.querySelector(selectors.loginPage);
  const customerLoginFormElement = document.querySelector(selectors.customerLoginForm);
  const wigInProgress = JSON.parse(localStorage.getItem('wigInProgress'));
  
  if (!loginPageElement) return;
  if (!wigInProgress) return;

  const redirectURL = wigInProgress;
  const htmlInput = document.createElement('input');

  htmlInput.type = 'hidden';
  htmlInput.name = 'return_to';
  htmlInput.value = redirectURL;

  customerLoginFormElement.append(htmlInput);
}

loginPage();